import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/priceSavingsReport'
import Component from 'components/Reports/PriceSavingsReport'

export default createListViewContainer({ actions, selectors: selectors.priceSavingsReport })(Component)
